// removed by extract-text-webpack-plugin
module.exports = {"container":"nj9CDfOahI6GOfpmn5zDP","input":"_27sU7_Qo5tK5UeKmzpTD9H"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Auth/Text/styles.css
// module id = 2627
// module chunks = 0